import { IonChip, IonGrid, IonIcon, IonLabel, IonRow, IonToolbar } from '@ionic/react'
import { closeCircleOutline } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getFilterSelector } from '../selectors/getFilter.selector'
import {
  clearFilterStatus,
  filterCompleteStatus,
  filterIncompleteStatus,
  filterNeedsReviewStatus,
} from '../store/home.actions'

import './filter.component.css'

const FilterComponent: React.FC = (): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const filter = useSelector(getFilterSelector)
  const { showClearFiltersButton, incompleteFilterOn, completeFilterOn, needsReviewFilterOn } = filter

  return (
    <IonToolbar color='light'>
      <IonRow class='ion-padding-top'>
        <IonLabel color='medium'>{t('home.FilterByStatus')}</IonLabel>
      </IonRow>
      <IonGrid class='ion-no-padding ion-margin-top'>
        <IonRow class='ion-nowrap no-flex-shrink'>
          {showClearFiltersButton && (
            <IonIcon
              qa-id='clear_filters_icon'
              class='ion-align-self-center'
              size='large'
              icon={closeCircleOutline}
              color='medium'
              onClick={() => dispatch(clearFilterStatus())}
            />
          )}
          <IonChip outline={!incompleteFilterOn} onClick={() => dispatch(filterIncompleteStatus())}>
            <IonLabel>{t('home.status.Incomplete')}</IonLabel>
          </IonChip>
          <IonChip outline={!completeFilterOn} onClick={() => dispatch(filterCompleteStatus())}>
            <IonLabel>{t('home.status.Complete')}</IonLabel>
          </IonChip>
          <IonChip outline={!needsReviewFilterOn} onClick={() => dispatch(filterNeedsReviewStatus())}>
            <IonLabel>{t('home.status.NeedsReview')}</IonLabel>
          </IonChip>
        </IonRow>
      </IonGrid>
    </IonToolbar>
  )
}

export default FilterComponent
